<template>
<div class="top-twenty-businesses-accordion">
  <div class="top-twenty-businesses-accordion__block-title" @click="changeActive">
    <div class="top-twenty-businesses-accordion__block-gov-title" v-if="type !== 'product'">
      <p class="top-twenty-businesses-accordion__block-gov-title-count" v-if="!last">
        {{last ? ' ' : Number(id)}}
      </p>
      <p
          v-if="!last"
          class="top-twenty-businesses-accordion__block-gov-title-state"
          :class="
          element.position_diff !== null && Number(element.position_diff) !== 0
           ? Number(element.position_diff) > 0 ? 'top-twenty-businesses-accordion__block-gov-title-state_up'
           : 'top-twenty-businesses-accordion__block-gov-title-state_down'
           : 'top-twenty-businesses-accordion__block-gov-title-state_default'">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path d="M9.29241 10.9706C8.8921 11.4906 8.1079 11.4906 7.70759 10.9706L4.54322 6.85999C4.03703 6.20242 4.50579 5.25 5.33563 5.25L11.6644 5.25C12.4942 5.25 12.963 6.20242 12.4568 6.85999L9.29241 10.9706Z" fill="#DE4A2A"/>
        </svg>
        <span > {{Math.abs(element.position_diff)}}</span>

      </p>
      <h3 class="top-twenty-businesses-accordion__title" v-html="title">
      </h3>
    </div>
    <h3 class="top-twenty-businesses-accordion__title" v-html="title" v-else>
    </h3>
    <div class="top-twenty-businesses-accordion__plus" :class="{ 'top-twenty-businesses-accordion__plus_minus': isActive }">
      <i></i>
      <i></i>
    </div>
  </div>
  <div class="top-twenty-businesses-accordion__content" v-if="type === 'product'" :class="{ 'top-twenty-businesses-accordion__content_full': isActive } ">
    <div class="top-twenty-businesses-accordion__content-block">
      <div class="top-twenty-businesses-accordion__line">
        <p>Количество тыс. шт.</p>
        <p v-if="element?.quantity" v-html="element.quantity"></p>
      </div>
      <div class="top-twenty-businesses-accordion__line">
        <p>{{ measureType }}</p>
        <p :class="Number(element.quantity_diff) !== 0 ? element.quantity_diff > 0 ? 'up': 'down' : 'default'">
          <span style="color: #252628" v-if="element.quantity_diff === '-'">{{element.quantity_diff}}</span>
          <span v-else-if="Number(element.quantity_diff) !== 0" v-html="makeNumber(element.quantity_diff)"></span>
          <span v-else>0%</span>
        </p>
      </div>
    </div>
    <div class="top-twenty-businesses-accordion__content-block">
      <div class="top-twenty-businesses-accordion__line">
        <p>Объем млрд ₽</p>
        <p v-if="element?.volume" v-html="element.volume"></p>
      </div>
      <div class="top-twenty-businesses-accordion__line">
        <p>{{ measureType }}</p>
        <p :class="Number(element.volume_diff) !== 0 ? element.volume_diff > 0 ? 'up': 'down' : 'default'">
          <span style="color: #252628" v-if="element.volume_diff === '-'">{{element.volume_diff}}</span>
          <span v-else-if="Number(element.volume_diff) !== 0" v-html="makeNumber(element.volume_diff)"></span>
          <span v-else>0%</span>
        </p>
      </div>
    </div>
  </div>
  <div class="top-twenty-businesses-accordion__content" v-else :class="{ 'top-twenty-businesses-accordion__content_full': isActive }">
    <div class="top-twenty-businesses-accordion__content-block">
      <div class="top-twenty-businesses-accordion__line">
        <p>Объем выданных кредитов млрд ₽</p>
        <p v-if="element?.volume" v-html="element.volume"></p>
      </div>
      <div class="top-twenty-businesses-accordion__line">
        <p>{{ measureType }}</p>
        <p :class="Number(element.volume_diff) !== 0 ? element.volume_diff > 0 ? 'up': 'down' : 'default'">
          <span style="color: #252628" v-if="element.volume_diff === '-'">{{element.volume_diff}}</span>
          <span v-else-if="Number(element.volume_diff) !== 0" v-html="element.volume_diff ? makeNumber(element.volume_diff ) : 0 + '%'"></span>
          <span v-else>0%</span>
        </p>
      </div>
    </div>
    <div class="top-twenty-businesses-accordion__content-block">
      <div class="top-twenty-businesses-accordion__line">
        <p>Количество выданных кредитов тыс. шт.</p>
        <p v-if="element?.quantity" v-html="element.quantity"></p>
      </div>
      <div class="top-twenty-businesses-accordion__line">
        <p>{{ measureType }}</p>
        <p :class="Number(element.quantity_diff) !== 0 ? element.quantity_diff > 0 ? 'up': 'down' : 'default'">
          <span style="color: #252628" v-if="element.quantity_diff === '-'">{{element.quantity_diff}}</span>
          <span v-else-if="Number(element.quantity_diff) !== 0" v-html="element.quantity_diff ?  makeNumber(element.quantity_diff) : 0 + '%'"></span>
          <span v-else>0%</span>
        </p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: "TopTwentyBusinessesAccordion",
  props: {
    id: {
      type: String,
      default(){
        return ''
      }
    },
    last:{
      type: Boolean,
      default(){
        return false
      }
    },
    title: {
      type: String,
      default() {
        return "Имя";
      }
    },
    element: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default(){
        return 'product'
      }
    },
    measureType: {
      type: String,
      default() {
        return 'м/м'
      }
    }
  },
  data(){
    return {
      isActive: false
    }
  },
  methods: {
    changeActive(){
      this.isActive = !this.isActive
    },
    makeNumber(el){
      return el < 0 ? el + '%' : '+'+Math.abs(el)+'%'
    },
  }
}
</script>